import { ExtendedCartItem, GQL_ID, Product } from '@@types'

import i18n from '@app/i18n'

import { useMutateAddFavoriteProduct, useMutateRemoveFavoriteProduct } from '@entities/Product'

import { useModalStore } from '@features/modal'
import InfoModal from '@features/modal/ui/error'
import styles from '@features/modal/ui/styles.module.scss'

import { useAnalytics } from '@shared/lib/analytics'

const modalStore = useModalStore.getState()

const t = i18n.t

const openErrorInfoModal = (errorTransKey?: string) => {
  modalStore.openModal('info', <InfoModal />, {
    title: t('common:modal.error.title'),
    description:
      t(`errors:${errorTransKey}`) ?? t('common:modal.error.description'),
    classes: {
      content: styles['error-info-modal-content'],
    },
  })
}

export const useToggleFavorite = () => {

  const [ addToFavorites ] = useMutateAddFavoriteProduct()

  const [ removeFromFavorites ] = useMutateRemoveFavoriteProduct()

  const { addToWishlist } = useAnalytics()

  const toggleFavorite = async (productId: GQL_ID, isFavorite: boolean, product?: Product | ExtendedCartItem) => {
    try {
      if (isFavorite) {
        await removeFromFavorites({
          variables: { product_id: productId },
          context: { productId }
        })
      }
      else {
        await addToFavorites({
          variables: { product_id: productId },
          context: { productId },
        })
        // Track add to wishlist
        if (product) {
          addToWishlist(product)
        }
      }
    }
    catch (error) {
      console.error('Favorite error:', error)
      openErrorInfoModal('favorite_toggle_error')
    }
  }

  return { toggleFavorite }
}
